import { min } from "lodash"

export default {
  debug: false,
  state: {
    // 编辑器版本
    kernelVersion: '1.0.0',
    // 备份的节目信息
    programInfoBakList: [],
    // 备份的节目最大数量
    programInfoBakCount: 20,
    // 当前的节目下标
    currentProgramInfoIndex: -1,

    // 正在编辑的节目信息
    programInfo: null,
    // 正在编辑的节目页下标
    currentPageIdx: 0,
    // 正在编辑的页面的组件列表
    currentPageComponentList: [],
    // 正在编辑（激活）的组件
    activeComponent: null,
    // 正在编辑（激活）的组件下标
    activeComponentIdx: 0,

    // 从服务器获取的组件列表 用户编辑节目时可以使用的组件
    componentList: [
      { name: 'PriceTag', type: 'TmPriceTag', icon: 'priceTag', enabled: true },
      { name: 'Image', type: 'TmMultiImg', icon: 'multiimg', enabled: true },
      { name: 'Video', type: 'TmVideo', icon: 'video', enabled: true },
      { name: 'QRCode', type: 'TmQRCode', icon: 'qrCode', enabled: true },
      { name: 'AD', type: 'TmAd', icon: 'ad', enabled: true },
    ],
    //添加价签模板时的可使用的组件
    componentList1: [
      { name: 'Text', type: 'TmText', icon: 'text', enabled: true },
      { name: 'Number', type: 'TmNumber', icon: 'number', enabled: true },
      { name: 'Line', type: 'TmLine', icon: 'line', enabled: true },
      { name: 'Block', type: 'TmBlock', icon: 'block', enabled: true },
      { name: 'Image', type: 'TmMultiImg', icon: 'multiimg', enabled: true },
      { name: 'Time', type: 'TmTime', icon: 'time', enabled: true },
      { name: 'Rating', type: 'TmValuation', icon: 'goodAppraise', enabled: true },
      { name: 'BarCode', type: 'TmBarCode', icon: 'barCode', enabled: true },
      { name: 'QRCode', type: 'TmQRCode', icon: 'qrCode', enabled: true },
    ],

     //添加ESL价签模板时的可使用的组件
     componentList2: [
      { name: 'Text', type: 'TmText', icon: 'text', enabled: true },
      { name: 'Number', type: 'TmNumber', icon: 'number', enabled: true },
      { name: 'Image', type: 'TmMultiImg', icon: 'multiimg', enabled: true },
      { name: 'Line', type: 'TmLine', icon: 'line', enabled: true },
      { name: 'Block', type: 'TmBlock', icon: 'block', enabled: true },
      { name: 'Time', type: 'TmTime', icon: 'time', enabled: true },
      { name: 'Rating', type: 'TmValuation', icon: 'goodAppraise', enabled: true },
      { name: 'QRCode', type: 'TmQRCode', icon: 'qrCode', enabled: true },
      { name: 'BarCode', type: 'TmBarCode', icon: 'barCode', enabled: true },
    ],

    // 是否正在截图
    isScreenshotting: false,
    // 是否显示添加图片的dialog
    selectImgDialogVisible: false,
    // 是否显示选择商品的dialog
    selectGoodsDialogVisible: false,
    // 是否显示添加价签的dialog
    selectPriceTagDialogVisible: false,
    // 是否显示添加编码的dialog
    addCodeDialogVisible: false,
    // 是否显示添加视频的dialog
    selectVideoDialogVisible: false,
    // 是否显示添加网页的dialog
    addWebPageDialogVisible: false,
    // 是否显示添加音乐的dialog
    addMusicDialogVisible: false,
    // 是否显示选择数据源的dialog
    addDatasetDialogVisible: false,
    // 是否显示编辑节目的dialog
    editPageDialogVisible: false,
    // 编辑的节目的下标
    editPageIdx: undefined,

    // 右键菜单的位置,
    ctxMenuLeft: 0,
    ctxMenuTop: 0,
    // 右键菜单是否显示
    ctxMenuVisible: false,

    // 画布右键菜单的位置
    canvasMenuVisible: false,
    canvasMenuLeft: 1,
    canvasMenuTop: 1,

    // 网格菜单的位置和是否显示
    gridMenuLeft: 1,
    gridMenuTop: 1,
    gridMenuVisible: false,
    // 是否显示网格
    gridVisible: false,
    // 网格宽度
    gridWidth: 10,
    // 网格线颜色
    gridColor: '#000',
    // 水平网格线的纵坐标
    yList: [],
    // 竖直网格线的横坐标
    xList: [],

    // 是否正在保存
    isSaveBtnLoading: false,

    // 记录合适的缩放比 初始值1.0
    suitableScale: 1.0,

    // 是否显示ruler
    rulerVisible: true,
    // 是否显示右下角导航
    navigatorVisible: false,
    // 是否显示预览
    previewVisible: false,

    // ESL商品列表选择是否显示
    goodsListVisible: false,

    //  是否显示ESL预览
    previewEslVisible: false,

    // 选择图片后的操作 ADD_COMPONENT ADD_IMAGE SET_PROGRAM_BG_IMG
    selectImgOperation: 'ADD_COMPONENT',
    // 选择价签后的操作 ADD_COMPONENT ADD_IMAGE SET_PROGRAM_BG_IMG
    selectPriceTagOperation: 'ADD_COMPONENT',
    // 选择编码后的操作 ADD_COMPONENT ADD_IMAGE SET_PROGRAM_BG_IMG
    selectCodeOperation: 'ADD_COMPONENT',
    // 选择视频后的操作 ADD_COMPONENT ADD_VIDEO
    selectVideoOperation: 'ADD_COMPONENT',
    // 选择音乐后的操作： ADD_COMPONENT, REPLACE_URL
    selectMusicOperation: 'ADD_COMPONENT',
    // 选择PDF后的操作： ADD_COMPONENT, REPLACE_PDF
    selectPdfOperation: 'ADD_COMPONENT',

    // 右侧编辑面板是否显示
    rightPanelVisible: true,

    // 设计区域宽
    designAreaWidth: undefined,
    // 设计区域高
    designAreaHeight: undefined,
    // 画布区域X坐标
    canvasAreaX: undefined,
    // 画布区域Y坐标
    canvasAreaY: undefined,
    // 画布坐标
    canvasLeft: undefined,
    // 画布坐标
    canvasTop: undefined,

    // 鼠标样式
    cursor: 'default',
    // 鼠标横坐标
    cursorX: 1,
    // 鼠标纵坐标
    cursorY: 1,

    // 区域列表
    districtList: [],
    // 高德API的天气对象
    gdWeather: null,

    // 是否显示组件列表（是否展开组件列表）
    showComponentList: 1,

    // 是否显示选择模板的dialog
    selectTemplateDialogVisible: false,
    // 添加直播流输入地址的dialog
    addLiveBroadcastDialogVisible: false,

    // 虚假的x、y 0<=x<=width 0<=y<=height
    fakeX: 0,
    fakeY: 0,

    // 添加文档/PDF的dialog是否显示
    addPdfDialogVisible: false,

    // 自定义分辨率的dailog是否显示
    customResolutionDialogVisible: false,
    //商品字段信息
    goodsFields: [],
    goodsOptions: [],

    // 是否选中ctrl建
    isCtrl: false,
    // 多选组件
    multipleComponentList: []
  },

  // 更新区域列表
  updateDistrictList(districtList) {
    if (this.debug) {
      // console.log(`updateDistrictList triggered with ${JSON.stringify(districtList)}`)
    }
    this.state.districtList = JSON.parse(JSON.stringify(districtList))
  },

  // 检测到用户进行了操作就调用这个方法进行备份，用来撤销/恢复
  backup(nVal) {
    if (JSON.stringify(nVal) !== JSON.stringify(this.state.programInfoBakList[this.state.currentProgramInfoIndex])) {
      if (this.state.programInfoBakList.length === this.state.currentProgramInfoIndex) {
        // 插入到最后的
        this.state.programInfoBakList.push(JSON.parse(JSON.stringify(nVal)))
        if (this.state.programInfoBakList.length > this.state.programInfoBakCount) {
          // 如果已经超过限制，删除最前边一个
          this.state.programInfoBakList.splice(0, 1)
        } else {
          this.state.currentProgramInfoIndex += 1
        }
      } else {
        this.state.currentProgramInfoIndex += 1
        // 插入到中间
        this.state.programInfoBakList.splice(this.state.currentProgramInfoIndex, 0, JSON.parse(JSON.stringify(nVal)))
        // 删除后边的元素
        this.state.programInfoBakList.splice(this.state.currentProgramInfoIndex + 1, this.state.programInfoBakList.length - this.state.currentProgramInfoIndex - 1)
      }
    }
  },

  // 更新节目信息 会更新一些相关信息
  updateProgramInfo(nVal, flag) {
    if (this.debug) {
      console.log(`updateProgramInfo triggered with`)
    }
    const update = () => {
      if (JSON.stringify(this.state.programInfo) !== JSON.stringify(nVal)) {
        this.state.programInfo = JSON.parse(JSON.stringify(nVal))
        const currentPage = this.state.programInfo.pages[this.state.currentPageIdx]
        this.updateCurrentPageComponentList(currentPage.componentList)
        this.updateActiveComponentIdx(this.state.activeComponentIdx || 0)
      }
    }
    if (this.state.programInfo === null) {
      update()
      this.calcXYList()
    } else {
      update()
    }
  },

  // 更新场景播放时长
  updateDuration() {
    console.log('更新场景播放时长')
    let duration = 10, videoCom = 0, imgCom = 0, liveCom = 0, pdfCom = 0, adCom = 0
    let currentPage = this.state.programInfo.pages[this.state.currentPageIdx]
    if (currentPage.componentList) {
      for (let m = 0; m < currentPage.componentList.length; m++) {
        let comp = currentPage.componentList[m]
        if (comp.type == 'TumengMultiImg') {
          for (let n = 0; n < comp.imgList.length; n++) {
            imgCom += parseInt(comp.imgList[n].duration)
          }
        } else if (comp.type == 'TumengVideo') {
          for (let h = 0; h < comp.videoList.length; h++) {
            videoCom += parseInt(comp.videoList[h].duration)
          }
        } else if (comp.type == 'TumengAd') {
          for (let j = 0; j < comp.adList.length; j++) {
            adCom += parseInt(comp.adList[j].duration)
          }
        } else if (comp.type == 'TumengPdf') {
          pdfCom = parseInt(comp.interval) * parseInt(comp.pages)
        } else if (comp.type == 'TumengLiveBroadcast') {
          liveCom = parseInt(comp.duration)
        }
      }

      if (liveCom > duration) {
        duration = liveCom
      }

      if (videoCom > duration) {
        duration = videoCom
      }

      if (imgCom > duration) {
        duration = imgCom
      }

      if (pdfCom > duration) {
        duration = pdfCom
      }

    }
    this.state.programInfo.pages[this.state.currentPageIdx].duration = duration
  },

  // 撤销
  undo() {
    this.state.currentProgramInfoIndex -= 1
    this.updateProgramInfo(this.state.programInfoBakList[this.state.currentProgramInfoIndex])
  },

  // 恢复
  redo() {
    this.state.currentProgramInfoIndex += 1
    this.updateProgramInfo(this.state.programInfoBakList[this.state.currentProgramInfoIndex])
  },

  // 更新当前编辑页的下标
  updateCurrentPageIdx(val) {
    if (this.debug) {
      console.log(`updateCurrentPageIdx triggered with ${JSON.stringify(val)}`)
    }
    this.state.currentPageIdx = val
    this.state.currentPageComponentList = this.state.programInfo.pages[val].componentList
  },

  // 更新当前页节目信息：换页时候被调用
  updateCurrentPageComponentList(val) {
    if (this.debug) {
      console.log(`updateCurrentPageComponentList triggered with ${JSON.stringify(val)}`)
    }
    console.log(val)
    this.state.currentPageComponentList = val
  },

  // 添加组件走这个方法
  addComponent(component) {
    if (this.debug) {
      console.log(`addComponent triggered with ${JSON.stringify(component)}`)
    }
    let i = this.state.currentPageComponentList.length === 0 ? 9 : this.state.currentPageComponentList[0].zIndex
    for (let j = 0; j < this.state.currentPageComponentList.length; j++) {
      if (this.state.currentPageComponentList[j].zIndex > i) {
        i = this.state.currentPageComponentList[j].zIndex
        // console.log('找到了比i大的数字 i = ', i)
      }
    }
    component.zIndex = i + 1
    component.groupId = this.state.showComponentList
    this.state.programInfo.pages[this.state.currentPageIdx].componentList.push(component)
    this.updateProgramInfo(this.state.programInfo)
    this.updateActiveComponentIdx(this.state.programInfo.pages[this.state.currentPageIdx].componentList.length - 1)
  },

  // 复制的page粘贴时走这个方法
  pasteComponents(components, idx) {
    if (this.debug) {
      console.log(`pasteComponents triggered with ${components}`)
    }
    this.state.programInfo.pages[idx].componentList = components
    console.log(this.state.programInfo.pages)
    this.updateProgramInfo(this.state.programInfo)
  },

  // 添加页面走这个方法
  addPage(page) {
    if (this.debug) {
      console.log(`addPage triggered with ${JSON.stringify(page)}`)
    }
    this.state.programInfo.pages.push(page)
  },

  // 插入模板，插入几个page就要删除几个page
  insertTemplate(pages) {
    // console.log('pages  ', pages)
    this.state.programInfo.pages.splice(
      this.state.currentPageIdx,
      pages.length,
      ...pages
    )
    this.state.currentPageComponentList = this.state.programInfo.pages[this.state.currentPageIdx].componentList
    this.updateActiveComponentIdx(undefined)
  },

  // 删除页面走这个方法
  deletePage(idx) {
    if (this.debug) {
      console.log(`deletePage triggered with ${idx}`)
    }
    this.state.programInfo.pages.splice(idx, 1)
    if (idx === this.state.programInfo.pages.length) {
      this.updateCurrentPageIdx(idx - 1)
    }
  },

  // 更新选择商品dialog是否可见信息
  updateSelectGoodsDialogVisible(nVal) {
    if (this.debug) {
      console.log(`updateSelectGoodsDialogVisible triggered with ${nVal}`)
    }
    this.state.selectGoodsDialogVisible = nVal
  },
  // 更新选择图片dialog是否可见信息
  updateSelectImgDialogVisible(nVal) {
    if (this.debug) {
      console.log(`updateSelectImgDialogVisible triggered with ${nVal}`)
    }
    this.state.selectImgDialogVisible = nVal
  },
  // 更新选择价签dialog是否可见信息
  updateSelectPriceTagDialogVisible(nVal) {
    if (this.debug) {
      console.log(`updateSelectPriceTagDialogVisible triggered with ${nVal}`)
    }
    this.state.selectPriceTagDialogVisible = nVal
  },

  // 更新选择视频dialog是否可见信息
  updateSelectVideoDialogVisible(nVal) {
    if (this.debug) {
      console.log(`updateSelectVideoDialogVisible triggered with ${nVal}`)
    }
    this.state.selectVideoDialogVisible = nVal
  },

  // 更新选择视频dialog是否可见信息
  updateAddWebPageDialogVisible(nVal) {
    if (this.debug) {
      console.log(`updateAddWebPageDialogVisible triggered with ${nVal}`)
    }
    this.state.addWebPageDialogVisible = nVal
  },

  updateAddMusicDialogVisible(val) {
    if (this.debug) {
      console.log(`updateAddMusicDialogVisible triggered with ${val}`)
    }
    this.state.addMusicDialogVisible = val
  },

  updateSelectDatasetDialogVisible(val) {
    if (this.debug) {
      console.log(`updateAddDatasetDialogVisible triggered with ${val}`)
    }
    this.state.addDatasetDialogVisible = val
  },

  // 更新激活组件的下标 更新激活组件对象
  updateActiveComponentIdx(val) {
    if (this.debug) {
      console.log(`updateActiveComponentIdx triggered with ${val}`)
    }
    this.state.activeComponentIdx = val
    if (val === undefined || val === null) {
      this.state.activeComponent = null
      if (this.state.multipleComponentList.length) {
        this.state.multipleComponentList = []
      }
    } else {
      this.state.activeComponent = this.state.programInfo.pages[this.state.currentPageIdx].componentList[val]
    }
    this.updateDuration()
  },

  // 设置右键菜单位置和显隐
  updateCtxMenuArgs(visible, left = 0, top = 0) {
    if (this.debug) {
      console.log(`updateCtxMenuArgs triggered with ${visible} ${left} ${top}`)
    }
    this.state.ctxMenuVisible = visible
    if (left || top) {
      this.state.ctxMenuLeft = left
      this.state.ctxMenuTop = top
    }
  },

  updateCanvasMenuArgs(visible, left = 1, top = 1) {
    this.state.canvasMenuVisible = visible
    this.state.canvasMenuLeft = left
    this.state.canvasMenuTop = top
  },
  updateGridMenuArgs(visible, left = 1, top = 1) {
    this.state.gridMenuVisible = visible
    this.state.gridMenuLeft = left
    this.state.gridMenuTop = top
  },

  updateGridWidth(width) {
    this.state.gridWidth = width
    this.calcXYList()
  },

  calcXYList() {
    this.state.xList = []
    this.state.yList = []

    let i = this.state.gridWidth
    while (i <= this.state.programInfo.height) {
      this.state.yList.push(i)
      i += this.state.gridWidth
    }

    i = this.state.gridWidth
    while (i <= this.state.programInfo.width) {
      this.state.xList.push(i)
      i += this.state.gridWidth
    }
  },

  // 设置右下角拖拽导航是否显示
  updateNavigatorVisible(val) {
    if (this.debug) {
      console.log(`updateNavigatorVisible triggered with ${val}`)
    }
    this.state.navigatorVisible = val
  },

  // 设置ruler是否显示
  updateRulerVisible(val) {
    if (this.debug) {
      console.log(`updateRulerVisible triggered with ${val}`)
    }
    this.state.rulerVisible = val
  },

  // 设置预览页面是否显示
  updatePreviewVisible(val) {
    if (this.debug) {
      console.log(`updatePreviewVisible triggered with ${val}`)
    }
    this.state.previewVisible = val
  },

  // 设置ESL商品列表选择页是否显示
  updateGoodsListVisible(val){
    if (this.debug) {
      console.log(`updateGoodsListVisible triggered with ${val}`)
    }
    this.state.goodsListVisible = val
  },

  // 设置ESL预览页面是否显示
  updatePreviewEslVisible(val) {
    if (this.debug) {
      console.log(`updatePreviewEslVisible triggered with ${val}`)
    }
    this.state.previewEslVisible = val
  },

  // 换页。在分页管理那里点击，传递过来的参数是下标（数字）；否则是对象
  updateCurrentPage(val) {
    if (this.debug) {
      console.log(`updateCurrentPage triggered with ${JSON.stringify(val)}`)
    }
    if (typeof val === 'number') {
      this.state.currentPageIdx = val
      this.updateCurrentPageComponentList(this.state.programInfo.pages[this.state.currentPageIdx].componentList)
    } else {
      this.updateCurrentPageComponentList(val)
      for (let i = 0, pages = this.state.programInfo.pages; i < pages.length; i++) {
        if (JSON.stringify(pages[i]) === JSON.stringify(val)) {
          this.state.currentPageIdx = i
          break
        }
      }
    }
    this.updateActiveComponentIdx(undefined)
  },

  // 选择了商品后的操作
  SET_SELECT_GOODS_OPERATION(operation) {
    if (this.debug) {
      console.log(`SET_SELECT_GOODS_OPERATION triggered with ${operation}`)
    }
    this.state.selectGoodsOperation = operation
  },

  // 选择了图片后的操作
  SET_SELECT_IMG_OPERATION(operation) {
    if (this.debug) {
      console.log(`SET_SELECT_IMG_OPERATION triggered with ${operation}`)
    }
    this.state.selectImgOperation = operation
  },

  // 选择了价签后的操作
  SET_SELECT_PRICE_TAG_OPERATION(operation) {
    if (this.debug) {
      console.log(`SET_SELECT_PRICE_TAG_OPERATION triggered with ${operation}`)
    }
    this.state.selectPriceTagOperation = operation
  },

  // 选择了编码后的操作
  SET_SELECT_CODE_OPERATION(operation) {
    if (this.debug) {
      console.log(`SET_SELECT_CODE_OPERATION triggered with ${operation}`)
    }
    this.state.selectCodeOperation = operation
  },

  updateAddCodeDialogVisible(val) {
    if (this.debug) {
      console.log(`updateAddCodeDialogVisible triggered with ${val}`)
    }
    this.state.addCodeDialogVisible = val
  },

  // 选择了视频后的操作
  SET_SELECT_VIDEO_OPERATION(operation) {
    if (this.debug) {
      console.log(`SET_SELECT_VIDEO_OPERATION triggered with ${operation}`)
    }
    this.state.selectVideoOperation = operation
  },

  // 选择了音乐后的操作
  SET_SELECT_MUSIC_OPERATION(operation) {
    if (this.debug) {
      console.log(`SET_SELECT_MUSIC_OPERATION triggered with ${operation}`)
    }
    this.state.selectMusicOperation = operation
  },

  // 更新design区域的宽高位置
  updateDesignSize({ width, height }) {
    if (this.debug) {
      console.log(`updateDesignSize triggered with ${width} ${height}`)
    }
    if (this.state.designAreaWidth !== width || this.state.designAreaHeight !== height) {
      this.state.designAreaWidth = width
      this.state.designAreaHeight = height
    }
  },

  // 更新canvas区域的位置
  updateCanvasPosition({ x, y }) {
    // if (this.debug) {
    //   console.log(`updateCanvasPosition triggered with ${x} ${y}`)
    // }
    if (this.state.canvasAreaX !== x) {
      this.state.canvasAreaX = x
    }
    if (this.state.canvasAreaY !== y) {
      this.state.canvasAreaY = y
    }
  },

  // 更新鼠标状态
  updateCursor(cursor) {
    if (this.debug) {
      console.log(`updateCursor triggered with ${cursor}`)
    }
    this.state.cursor = cursor
  },

  // 更新鼠标位置
  updateCursorPosition({ cursorX, cursorY }) {
    // if (this.debug) {
    //   console.log(`updateCursorPosition triggered with ${cursorX} ${cursorY}`)
    // }
    this.state.cursorX = cursorX
    this.state.cursorY = cursorY
  },

  // 设置画布位置
  setCanvasPosition({ canvasLeft, canvasTop }) {
    if (this.debug) {
      console.log(`setCanvasPosition triggered with ${canvasLeft} ${canvasTop}`)
    }
    this.state.canvasLeft = canvasLeft
    this.state.canvasTop = canvasTop
  },

  // 更新合适的缩放比
  updateSuitableScale(suitableScale) {
    if (this.debug) {
      console.log(`updateSuitableScale triggered with ${suitableScale}`)
    }
    this.state.suitableScale = suitableScale
  },

  // 设置天气对象
  setGdWeather(weather) {
    if (this.debug) {
      console.log(`setGdWeather triggered with ${weather}`)
    }
    this.state.gdWeather = weather
  },

  // 更新组件列表状态为展开/收缩
  updateShowComponentList(val) {
    if (this.debug) {
      console.log(`updateShowComponentList triggered with ${val}`)
    }
    this.state.showComponentList = val
  },

  // npi newProgramInfo 缩写
  removeComponentAtIdx(idx) {
    this.state.programInfo.pages[this.state.currentPageIdx].componentList.splice(idx, 1)
    this.updateActiveComponentIdx(undefined)
  },

  updateIsScreenshotting(val) {
    if (this.debug) {
      console.log(`updateIsScreenshotting triggered with ${val}`)
    }
    this.state.isScreenshotting = val
  },

  updateSelectTemplateDialogVisible(val) {
    if (this.debug) {
      console.log(`updateSelectTemplateDialogVisible triggered with ${val}`)
    }
    this.state.selectTemplateDialogVisible = val
  },

  updateAddLiveBroadcastDialogVisible(val) {
    if (this.debug) {
      console.log(`updateAddLiveBroadcastDialogVisible triggered with ${val}`)
    }
    this.state.addLiveBroadcastDialogVisible = val
  },

  setProgramSize({ width, height }) {
    if (this.debug) {
      console.log(`setProgramSize triggered with ${width} ${height}`)
    }
    this.state.programInfo.width = width
    this.state.programInfo.height = height
  },

  updateRightPanelVisible(val) {
    if (this.debug) {
      console.log(`updateRightPanelVisible triggered with ${val}`)
    }
    this.state.rightPanelVisible = val
  },

  updateEditPageDialogVisible(val, idx) {
    if (this.debug) {
      console.log(`updateEditPageDialogVisible triggered with ${val} ${idx}`)
    }
    this.state.editPageDialogVisible = val
    this.state.editPageIdx = idx
  },

  setPageInfo(title, duration) {
    if (this.debug) {
      console.log(`setPageInfo triggered with ${title} ${duration}`)
    }
    const page = this.state.programInfo.pages[this.state.editPageIdx]
    page.title = title
    page.duration = duration
  },

  updateFakeXY(x, y) {
    if (x > this.state.programInfo.width) {
      x = this.state.programInfo.width
    }
    if (y > this.state.programInfo.height) {
      y = this.state.programInfo.height
    }
    if (x < 0) {
      x = 0
    }
    if (y < 0) {
      y = 0
    }
    x = x.toFixed(0)
    y = y.toFixed(0)
    this.state.fakeX = x
    this.state.fakeY = y
  },

  updateAddPdfDialogVisible(val) {
    if (this.debug) {
      console.log(`updateAddPdfDialogVisible triggered with ${val}`)
    }
    this.state.addPdfDialogVisible = val
  },

  updateSelectPdfOperation(val) {
    if (this.debug) {
      console.log(`updateSelectPdfOperation triggered with ${val}`)
    }
    this.state.selectPdfOperation = val
  },

  updateCustomResolutionDialogVisible(val) {
    if (this.debug) {
      console.log(`updateCustomResolutionDialogVisible triggered with ${val}`)
    }
    this.state.customResolutionDialogVisible = val
  },

  setPageBGImg(val, imgId) {
    if (this.debug) {
      console.log(`setPageBGImg triggered with ${val}`)
    }
    // this.state.programInfo.bgImg = val
    this.state.programInfo.pages[this.state.currentPageIdx].bgImg = val
    this.state.programInfo.pages[this.state.currentPageIdx].imgId = imgId
  },

  updatePageBgColor(val) {
    if (this.debug) {
      console.log(`updatePageBgColor triggered with ${val}`)
    }
    this.state.programInfo.pages[this.state.currentPageIdx].bgColor = val
  },

  // 初始化多选组件
  initMultiple() {
    if (this.state.activeComponent && !this.state.multipleComponentList.length) {
      this.state.multipleComponentList = [this.state.activeComponent.componentId]
    }
  },
  // 多选组件新增
  addComponentForMultiple(val) {
    const com = this.state.programInfo.pages[this.state.currentPageIdx].componentList[val]
    const index = this.state.multipleComponentList.find(item => item === com.componentId)
    if (!index) {
      this.state.multipleComponentList.push(com.componentId)
    } else {
      this.state.multipleComponentList.splice(index, 1)
    }
  },
  // 多选组件新增
  clearComponentForMultiple() {
    this.state.multipleComponentList = []
  },
  // 多选组件移动
  updataMultipleComponent(left, top) {
    let mLeft = left - this.state.activeComponent.left
    let mTop = top - this.state.activeComponent.top
    this.state.currentPageComponentList.forEach((item) => {
      if (this.state.multipleComponentList.indexOf(item.componentId) !== -1) {
        let x = item.left + mLeft
        let y = item.top + mTop
        if (x < 0) {
          x = 0
        }
        if (y < 0) {
          y = 0
        }
        if (x + item.width > this.state.programInfo.width) {
          x = this.state.programInfo.width - item.width
        }
        if (y + item.height > this.state.programInfo.height) {
          y = this.state.programInfo.height - item.height
        }
        item.left = x
        item.top = y
      }
    })
  },
  // 多选组件分组
  groupMultipleComponent() {
    const {
      currentPageComponentList,
      multipleComponentList,
      showComponentList
    } = this.state
    currentPageComponentList.forEach((comp) => {
      if (multipleComponentList.indexOf(comp.componentId) !== -1) {
        comp.groupId = showComponentList + 1
        this.state.showComponentList = showComponentList + 1
      }
    })
  },

  // 多选组件对齐
  updataMultipleComponentAlign(alginFlag) {
    // console.log('========》〉》〉》〉》多选组件对齐', alginFlag)
    // console.log('全部组件list', this.state.currentPageComponentList)
    // console.log('选中组件id', this.state.activeComponent)
    const flag = alginFlag ? alginFlag : 'left'
    const multipleComponent = []
    const activeComponentlength = this.state.multipleComponentList.length
    // console.log(activeComponentlength)
    const x = 0, y = 0, xAll = this.state.programInfo.width, yAll = this.state.programInfo.height
    if (activeComponentlength < 1 && this.state.activeComponent) {
      // 单个组件选中时
      if (flag == 'left') {
        this.state.activeComponent.left = 0
      }
      if (flag == 'right') {
        this.state.activeComponent.left = xAll - this.state.activeComponent.width
        console.log('right')
      }
      if (flag == 'hc') {
        this.state.activeComponent.left = (xAll - this.state.activeComponent.width) / 2
      }
      if (flag == 'top') {
        this.state.activeComponent.top = 0
      }
      if (flag == 'bottom') {
        this.state.activeComponent.top = yAll - this.state.activeComponent.height
        console.log('right')
      }
      if (flag == 'vc') {
        this.state.activeComponent.top = (yAll - this.state.activeComponent.height) / 2
      }
    } else {
      this.state.currentPageComponentList.forEach((item) => {
        if (this.state.multipleComponentList.indexOf(item.componentId) !== -1) {
          multipleComponent.push(item)
        }
      })
      console.log(multipleComponent)
      
      const multipleComponentLength = multipleComponent.length
      const minX = Math.min(...multipleComponent.map(obj => obj.left));
      const maxX = Math.max(...multipleComponent.map(obj => obj.left));
      const minXWithWidth = Math.min(...multipleComponent.map(obj => parseInt(obj.left) + parseInt(obj.width)));
      const maxXWithWidth = Math.max(...multipleComponent.map(obj => parseInt(obj.left) + parseInt(obj.width)));
      const centerX = (minX + maxXWithWidth) / 2
      const spanX = (maxX - minXWithWidth) / (multipleComponentLength -1)

      const minY = Math.min(...multipleComponent.map(obj => obj.top));
      const maxY = Math.max(...multipleComponent.map(obj => obj.top));
      const maxYWithHeight = Math.max(...multipleComponent.map(obj => parseInt(obj.top) + parseInt(obj.height)));
      const centerY = (minY + maxYWithHeight) / 2
      const spanY = (maxY - minY) / (multipleComponentLength - 1)

      if(flag == 'ha'){
        multipleComponent.sort(function(a,b){
          const value1 = a['left'],value2 = b['left']
          return value1 -value2
        })
      }

      if(flag == 'va'){
        multipleComponent.sort(function(a,b){
          const value1 = a['top'],value2 = b['top']
          return value1 -value2
        })
      }


      console.log('.........======',multipleComponent)
      

      console.log(multipleComponentLength, minX, maxX, minY, maxY)
      multipleComponent.forEach((item,index) => {
        if (flag == 'left') {
          item.left = minX
        }
        if (flag == 'hc') {
          item.left = centerX - item.width / 2
        }
        if (flag == 'right') {
          item.left = maxXWithWidth - item.width
        }
        // 水平均分
        if (flag == 'ha') {
          if (index > 0 && index < multipleComponentLength - 1) {
            item.left = minX + spanX * index
          }
        }

        if (flag == 'top') {
          item.top = minY
        }
        if (flag == 'vc') {
          item.top = centerY - item.height / 2
        }
        if (flag == 'bottom') {
          item.top = maxYWithHeight - item.height
        }
        // 垂直均分
        if(flag == 'va'){
          if (index > 0 && index < multipleComponentLength - 1) {
            item.top = minY + spanY * index
          }
        }
      })

    }
    return
    // 对齐方式： left right hc ha   top bottom vc va
    let mLeft = left - this.state.activeComponent.left
    let mTop = top - this.state.activeComponent.top
    this.state.currentPageComponentList.forEach((item) => {
      if (this.state.multipleComponentList.indexOf(item.componentId) !== -1) {
        let x = item.left + mLeft
        let y = item.top + mTop
        if (x < 0) {
          x = 0
        }
        if (y < 0) {
          y = 0
        }
        if (x + item.width > this.state.programInfo.width) {
          x = this.state.programInfo.width - item.width
        }
        if (y + item.height > this.state.programInfo.height) {
          y = this.state.programInfo.height - item.height
        }
        item.left = x
        item.top = y
      }
    })
  },
}
